/* Config Imports */
import GeozoneRouteConfig from './geozones.route';  
/* Controller Imports */ 
import GeozonesCreateController from './create/create.controller';   
import GeozoneDetailsEventController from './geozone.details.event.controller'; /* Unclear controller/html purpose. */           
import GeozonesListController from './list/list.controller';                                                     
import GeozonesViewDeleteController from './delete-modal/delete.controller';            
import GeozonesViewTableAssetsModalController, { GeozoneAssetDeleteModalController } from './view/assets/assets.controller'; 
import GeozonesViewTableController from './view/view.controller';                     
import GeozonesViewTableLogController from './view/logz/log.controller';  
/* Directive Imports */             
import GeozonesViewTableMapDirective from './view/map/map.directive';                 
                  
const geozonesConfigModule = angular.module('app.configGeozones', [
    "ui.bootstrap",
    "ui.router",
    "gettext"
])
/* Config */
.config(GeozoneRouteConfig)
/* Default Controllers */
.controller('GeozonesCreateController', GeozonesCreateController)
.controller('GeozoneDetailsEventController', GeozoneDetailsEventController)
.controller('GeozonesListController', GeozonesListController)
.controller('GeozonesViewDeleteController', GeozonesViewDeleteController)
.controller('GeozonesViewTableController', GeozonesViewTableController)
.controller('GeozonesViewTableAssetsModalController', GeozonesViewTableAssetsModalController)
.controller('GeozonesViewTableLogController', GeozonesViewTableLogController)
/* Named Controllers */
.controller('geozoneAssetDeleteModalController', GeozoneAssetDeleteModalController)
/* Directives */
.directive('geozoneMap', GeozonesViewTableMapDirective);

export default geozonesConfigModule.name;